import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "📝", key: "notes" },
  { emoji: "📊", key: "spreadsheets" },
  { emoji: "🧠", key: "memory" },
  { emoji: "📱", key: "anotherApp" },
]

export default function CarsCurrentSetupPage() {
  return (
    <RadioCardListPage translationKey="carsCurrentSetup" options={OPTIONS} />
  )
}
